"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/constants";

export function CtaSection() {
  return (
    <section id="booking" className="relative overflow-hidden py-24 md:py-32">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/images/swimming-pool-night.jpg"
          alt="Mountain Nest pool at night"
          fill
          className="object-cover"
          sizes="100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/75 to-black/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-primary">
            Book Your Stay
          </p>
          <h2 className="mt-4 font-playfair text-3xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
            Ready to Experience
            <br />
            <span className="text-gradient-gold">{SITE.name}?</span>
          </h2>
          <p className="mt-6 text-lg text-white/70 md:text-xl">
            Starting from{" "}
            <span className="font-semibold text-primary">
              ₹{SITE.basePricePerNight.toLocaleString("en-IN")}/night
            </span>
          </p>

          <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <Button
              asChild
              size="lg"
              className="rounded-full bg-primary px-10 text-base font-semibold text-primary-foreground hover:bg-primary/90 gold-glow"
            >
              <Link href="/book">Book Now</Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="rounded-full border-white/30 px-10 text-base font-semibold text-white hover:bg-white/10 hover:border-white/50"
            >
              <a
                href={SITE.airbnbUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ExternalLink className="mr-2 size-4" />
                View on Airbnb
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
